module.exports = "pegasus/assets/theme4/google.png";